"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImagePreview = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _react = require("react");

var _material = require("@mui/material");

var _Modal = require("../../organisms/Modal");

var _ButtonV = require("../ButtonV2");

var _axios = _interopRequireDefault(require("axios"));

var _Image = require("../Image");

var _jsxRuntime = require("react/jsx-runtime");

var ImagePreview = function ImagePreview(props) {
  var className = props.className,
      width = props.width,
      sizeLoading = props.sizeLoading,
      colorLoading = props.colorLoading,
      downloadImgURL = props.downloadImgURL,
      imgURL = props.imgURL,
      modalImgURL = props.modalImgURL,
      imageName = props.imageName,
      showButtonDownload = props.showButtonDownload,
      componentDefault = props.componentDefault,
      componentDefaultModal = props.componentDefaultModal;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      imgLoad = _useState2[0],
      setImgLoad = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      imgLoadModal = _useState4[0],
      setImgLoadModal = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      loadingDownload = _useState8[0],
      setLoadingDownload = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      showModalImg = _useState10[0],
      setShowModalImg = _useState10[1];

  var _useState11 = (0, _react.useState)({
    show: false,
    title: "",
    message: "Ocurrió un error al descargar la imagen ¿Quieres intentarlo de nuevo?",
    icon: "info",
    buttons: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
      type: "white",
      borderType: "oval",
      label: "No",
      size: 12,
      onClick: function onClick(event) {
        setModalAlert(function (prev) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, prev), {}, {
            show: false
          });
        });
      }
    }, "btn-No"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
      type: "pink",
      borderType: "oval",
      label: "Intentar",
      size: 12,
      onClick: function onClick(event) {
        setModalAlert(function (prev) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, prev), {}, {
            show: false
          });
        });
        getImage();
      }
    }, "btn-Intentar")]
  }),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      modalAlert = _useState12[0],
      setModalAlert = _useState12[1];

  var getImage = function getImage() {
    //setLoadingDownload(true);
    var link = document.createElement("a");
    link.href = downloadImgURL;
    link.setAttribute("download", imageName !== null && imageName !== void 0 ? imageName : "image");
    link.style.display = "none";

    link.onerror = function () {
      setModalAlert(function (prev) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, prev), {}, {
          show: true
        });
      });
      return;
    };

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    className: className,
    width: width,
    children: [imgURL && (imgLoad === undefined || loading) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContainerLoading, {
      className: "container-loading",
      sizeLoading: sizeLoading,
      colorLoading: colorLoading,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFontawesome.FontAwesomeIcon, {
        className: "icon",
        pulse: true,
        icon: _freeSolidSvgIcons.faSpinner
      })
    }), (!imgURL || imgLoad === false && !loading) && componentDefault, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Img, {
      show: imgLoad && !loading,
      className: "img",
      src: imgURL,
      onLoad: function onLoad(event) {
        setImgLoad(true);
      },
      onError: function onError(event) {
        setImgLoad(false);
      },
      onClick: function onClick(event) {
        setShowModalImg(true);
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Modal, {
      open: showModalImg,
      disablePortal: true,
      closeAfterTransition: true,
      componentsProps: {
        root: {
          className: "container-modal"
        },
        backdrop: {
          timeout: 400,
          className: "container-background"
        }
      },
      onClick: function onClick(event) {
        if (!loadingDownload) setShowModalImg(false);
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Fade, {
        in: showModalImg,
        timeout: 400,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ContainerModalImg, {
          children: [showButtonDownload && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "container-header",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
              className: "container-btnDownload",
              type: "pink",
              size: 14,
              borderType: "circle",
              icon: _freeSolidSvgIcons.faArrowDown,
              isLoading: loadingDownload,
              onClick: function onClick(event) {
                event.stopPropagation();
                getImage();
              }
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.Image, {
            className: "container-imgModal",
            classNameImg: "img",
            sizeLoading: 100,
            colorLoading: "white",
            src: modalImgURL,
            componentDefault: componentDefaultModal
          })]
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
      show: modalAlert.show,
      title: modalAlert.title,
      message: modalAlert.message,
      icon: modalAlert.icon,
      buttons: modalAlert.buttons
    })]
  });
};

exports.ImagePreview = ImagePreview;